export enum GroupActionType {
  GET = "GET",
  LOAD = "LOAD",
  POST = "POST",
  SELECTED_GROUP = "SELECTED_GROUP"
}
